import * as serverApi from './server'

// eslint-disable-next-line import/prefer-default-export
export const getSupportedDomains = (queryParams) => serverApi.get('/v3/info/domains', queryParams)
